// import { Container, Modal } from 'react-bootstrap';
import { Container} from 'react-bootstrap';
import './style.scss';
import React, { useEffect, useState } from 'react';
import PagesGrid from '../elements/Sections/PagesGrid/PagesGrid';
// import { Play } from 'lucide-react';
import { useParams } from 'react-router';
import { ActivityStrapi } from '../../shared/interfaces'; // or use any play icon SVG
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
// import ReactPlayer from 'react-player'; // Bootstrap spinner
// import ReactPlayer from 'react-player'; // Bootstrap spinner
// import prishtinaVideo from "./../../assets/video/prishtina.mp4";


type ImageFormat = {
  ext: string;
  url: string;
  hash: string;
  mime: string;
  name: string;
  path: string | null;
  size: number;
  width: number;
  height: number;
};

type EmblemImage = {
  id: number;
  name: string;
  url: string;
  formats: {
    large?: ImageFormat;
    medium?: ImageFormat;
    small?: ImageFormat;
    thumbnail?: ImageFormat;
  };
  [key: string]: unknown; // allow other image attributes
};

type Branch = {
  id: number;
  name: string;
  director: string;
  foundationDate: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  mapLink: string;
  mapLinkWeb: string;
  emblem?: EmblemImage
};

type Teacher = {
  id: number;
  fullName: string;
  title?: string;
  image?: {
    url: string;
  };
};

function Branch() {
  const { city } = useParams();
  const [branchData, setBranchData] = useState<Branch | null>(null);
  const [teachers, setTeachers] = useState<Teacher[]>([]);
  const [activities, setActivities] = useState<ActivityStrapi[]>([]);
  // const [showVideo, setShowVideo] = useState(false);
  // const handleClose = () => setShowVideo(false);
  // const handleShow = () => setShowVideo(true);

  // Inside your component, add these:
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Submit function

  const handleSubscribe = async () => {
    if (!email || !branchData?.id) return;

    setSubmitting(true);
    setSubmitted(false);

    try {
      // Simulate network delay (e.g., 800ms)
      await new Promise((res) => setTimeout(res, 800));

      const res = await fetch('https://strapi-production-a706.up.railway.app/api/subscriptions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            email,
            filiali: branchData.id,
          },
        }),
      });

      if (!res.ok) throw new Error('Failed to subscribe');
      setSubmitted(true);
      toast.success('Jeni bere subscribe me sukses!');
    } catch (err) {
      console.error('Subscribe error:', err);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (city) {
      fetch(`https://strapi-production-a706.up.railway.app/api/branches?filters[city][$eq]=${city}&populate[emblem]=true`)
        .then((res) => res.json())
        .then((data) => setBranchData(data.data[0]))
        .catch((err) => console.error(err));

      fetch(
        `https://strapi-production-a706.up.railway.app/api/teachers?filters[filialet][city][$eq]=${city}&sort[0]=sequence:asc&populate[image]=true`,
      )
        .then((res) => res.json())
        .then((data) => setTeachers(data.data))
        .catch((err) => console.error('Failed to fetch teachers:', err));

      fetch(
          `https://strapi-production-a706.up.railway.app/api/activities?filters[filialet][city][$eq]=${city}&populate[images]=true&populate[activity_categories]=true&populate[mainImage]=true`
      )
        .then((res) => res.json())
        .then((data) => setActivities(data.data))
        .catch((err) => console.error('Failed to fetch acitivies:', err));
    }
  }, [city]);

  return (
    <div className="section branch pagesgrid">
      <Container>
        <div className="branch-main d-flex">
          <div className="main-left">
            {/*<div className="play">*/}
            {/*  /!* <Play className="w-16 h-16 text-white opacity-80 hover:opacity-100 transition" /> *!/*/}
            {/*</div> */}
            <img
                src={branchData?.emblem?.url}
                alt="Emblem"
                className="w-48 h-auto mt-4 rounded shadow"
            />
          </div>
          <div className="main-right">
            <div>
              <h1 className="text-3xl font-bold">{branchData?.name}</h1>
              <p className="mt-2 text-gray-300">
                Themeluar në vitin{' '}
                <strong>
                  {branchData?.foundationDate &&
                    new Date(branchData.foundationDate).getFullYear()}
                </strong>
                
              </p>
              <p className="text-sm text-blue-400">
                Drejtor i Filialit: <strong>{branchData?.director}</strong>
              </p>
              <p className="mt-3 text-gray-400">{branchData?.description}</p>
            </div>
          </div>
        </div>
      </Container>

      <Container>
        <div className="lecturers">
          <div className="title">
            <h2>Ligjëruesit</h2>
          </div>
          <div className="lecturers-plc">
            {teachers?.map((teacher) => {
              const img = teacher.image?.url || '/fallback-image.jpg'; // optional fallback

              return (
                <div className="lecturer" key={teacher.id}>
                  <div
                    className="lecturer-image"
                    style={{
                      backgroundImage: `url(${img})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'top center',
                    }}
                  ></div>
                  <p className="fullname">{teacher.fullName}</p>
                </div>
              );
            })}
          </div>
        </div>
      </Container>

      <PagesGrid activityList={activities}></PagesGrid>

      <Container>
        <div className="new-classes">
          <div className="title-desc">
            <p className="title">Regjistrohuni për grupin e rradhës</p>
            {/* <p className="desc">Klasa e Re fillon më 12 maj</p> */}
          </div>

          <div className="d-flex gap-2 flex-column flex-sm-row">
            <input
              placeholder="Emaili"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={submitting}
            />
            <button
              className="button button--secondary d-flex align-items-center justify-content-center"
              onClick={handleSubscribe}
              disabled={submitting}
            >
              {submitting ? (
                <Spinner animation="border" size="sm" role="status" />
              ) : (
                <span>{submitted ? 'Sukses!' : 'Subscribe'}</span>
              )}
            </button>
          </div>
        </div>
      </Container>

      <Container>
        <div className="iframe">
          <iframe
              title="Lokacioni i Akropolit të Ri"
              src={branchData?.mapLinkWeb}
              width="100%"
              height="450"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </Container>

      {/* <Modal show={showVideo} onHide={handleClose} centered size="lg">
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            <ReactPlayer
                src="https://www.youtube.com/watch?v=YOUR_VIDEO_ID"
                width="100%"
                height="100%"
                controls
                playing
            />
          </div>
        </Modal.Body>
      </Modal> */}
    </div>
  );
}

export default Branch;
